<template>
  <a
    ref="button"
    class="button responsive-font-size"
    @click="clicked"
    :style="coloursStyle"
    :class="{ disabled: disabled }"
  >
    {{ buttonText }}
    <div class="icon">
      <svg viewBox="0 0 24 24">
        <path :d="iconPath" />
      </svg>
    </div>
  </a>
</template>

<script>
import { mdiRefresh } from '@mdi/js'
import { mdiFullscreen } from '@mdi/js'
import { mdiFullscreenExit } from '@mdi/js'

import gsap from 'gsap'

export default {
  name: 'GruButton',
  props: {
    type: String,
    disabled: Boolean,
  },
  computed: {
    coloursStyle() {
      switch (this.type) {
        case 'reset':
          return {
            '--button-colour': 'var(--primary-pink)',
          }
        default:
          return {
            '--button-colour': 'var(--primary-green)',
          }
      }
    },
    buttonText() {
      switch (this.type) {
        case 'reset':
          return 'Reset'
        case 'enter-fullscreen':
          return 'Go fullscreen'
        case 'exit-fullscreen':
          return 'Exit fullscreen'
        default:
          return 'Unknown type'
      }
    },
    iconPath() {
      switch (this.type) {
        case 'reset':
          return mdiRefresh
        case 'enter-fullscreen':
          return mdiFullscreen
        case 'exit-fullscreen':
          return mdiFullscreenExit
        default:
          return ''
      }
    },
  },
  methods: {
    clicked() {
      if (this.disabled) {
        return
      }
      this.$emit('click')
      gsap.from(this.$refs['button'], {
        scale: 0.9,
        duration: 0.2,
      })
    },
  },
}
</script>

<style scoped>
.responsive-font-size {
  font-size: clamp(0px, 3.5vmin, 20px);
}

.button {
  display: inline-flex;
  align-items: center;
  padding: 0.5em 1em 0.5em 1em;
  color: white;
  background-color: var(--button-colour);
  font-family: 'Inter Medium';
  border-radius: 0.35em;
  cursor: pointer;
  margin-top: 0.5em;
}

.button:hover:not(.disabled) {
  filter: brightness(1.2);
}

.button.disabled {
  background-color: grey;
  opacity: 0.7;
  cursor: default;
}

.button.disabled:hover {
  background-color: grey;
}

.icon {
  width: 1.5em;
  height: 1.5em;
  margin-left: 0.25em;
}

.icon path {
  fill: white;
}
</style>
